function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMenuProfile = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "3.022 3.962 18.795 16.141",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M 12.212 4.38 C 7.956 4.38 4.508 7.828 4.508 12.078 C 4.508 16.328 7.956 19.776 12.206 19.776 C 16.456 19.776 19.904 16.328 19.904 12.078 C 19.904 7.828 16.462 4.38 12.212 4.38 Z M 8.354 17.618 C 8.728 15.833 10.313 14.495 12.212 14.495 C 14.111 14.495 15.672 15.833 16.07 17.618 C 14.997 18.407 13.665 18.878 12.212 18.878 C 10.783 18.878 9.445 18.407 8.354 17.618 Z M 9.855 10.89 C 9.855 9.582 10.922 8.533 12.212 8.533 C 13.502 8.533 14.569 9.6 14.569 10.89 C 14.569 12.18 13.502 13.247 12.212 13.247 C 10.922 13.247 9.855 12.198 9.855 10.89 Z M 16.866 17.262 C 16.402 15.586 15.051 14.278 13.357 13.874 C 14.545 13.41 15.413 12.259 15.413 10.89 C 15.413 9.136 13.984 7.708 12.23 7.708 C 10.476 7.708 9.047 9.136 9.047 10.89 C 9.047 12.241 9.891 13.41 11.103 13.874 C 9.409 14.278 8.059 15.586 7.595 17.262 C 6.184 15.99 5.274 14.139 5.274 12.084 C 5.274 8.256 8.396 5.128 12.23 5.128 C 16.058 5.128 19.187 8.25 19.187 12.084 C 19.162 14.133 18.276 15.99 16.866 17.262 Z",
  fill: "#646464",
  style: {}
}), /*#__PURE__*/React.createElement("path", {
  d: "M 12.459 9.13 C 12.278 9.148 12.158 9.293 12.158 9.474 C 12.176 9.655 12.32 9.775 12.501 9.775 C 12.887 9.757 13.207 10.034 13.225 10.42 C 13.243 10.601 13.387 10.722 13.568 10.722 C 13.749 10.722 13.87 10.559 13.87 10.378 C 13.809 9.637 13.182 9.094 12.459 9.13 Z",
  fill: "#646464",
  style: {}
}));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu-profile.5b46643f.svg";
export { ForwardRef as ReactComponent };